/**
 * display Element error if not loaded in 10s
 */
export var ELEMENT_TIMEOUT = 10000;